import BaseModelAPI from '../BaseModelAPI';

export default class QcVisualConfigList extends BaseModelAPI {

	static entity = 'qcvisualconfiglist'
	static entityName = 'qcvisualconfig';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
